import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Apollo, QueryRef } from 'apollo-angular';

import { map, startWith } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { PageChangedEvent } from '@cigna/ui/pagination';

import {
  DashboardWamUsersDocumentGQL,
  DashboardWamUsersQueryGQL,
  WamQueryGQL,
} from '@cigna/chcp/shared/graphql-util';

import {
  User,
  TinAccess,
} from '@cigna/chcp/working-with-cigna/manage-access-feature';
import { ManageAccessViewUserDialogComponent } from '../manage-access-view-user-dialog/manage-access-view-user-dialog.component';
import { GraphQLError } from 'graphql';

@Component({
  selector: 'cigna-manage-access-tile',
  templateUrl: './manage-access-tile.component.html',
  styleUrls: ['./manage-access-tile.component.scss', '../tile.scss'],
})
export class ManageAccessTileComponent implements OnInit {
  @Input() appContext = 'chcp';

  checkedUsers: string[] = [];

  itemsPerPage = 10;
  currentPage = 1;
  offset = 0;

  wamQuery: QueryRef<DashboardWamUsersQueryGQL>;
  dashboardDataGql$: Observable<{
    loading: boolean;
    data?: {
      wamDashboardUsers: WamQueryGQL;
    };
    errors?: readonly GraphQLError[] | null | undefined;
  }>;

  constructor(
    private apollo: Apollo,
    public dialog: MatDialog,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.wamQuery = this.apollo.watchQuery<any>({
      query: DashboardWamUsersDocumentGQL,
      variables: {
        input: {
          offset: 0,
          limit: this.itemsPerPage,
        },
      },
      errorPolicy: 'all',
    });
    this.dashboardDataGql$ = this.wamQuery.valueChanges.pipe(
      startWith({
        loading: true,
        data: {
          wamDashboardUsers: {
            users: [],
            total: 0,
          },
        },
        errors: undefined,
      }),
      map((result) => ({
        loading: false,
        data: {
          wamDashboardUsers: {
            users: result.data?.wamDashboardUsers?.users || [],
            total: result.data?.wamDashboardUsers?.total || 0,
          },
        },
        errors: result.errors,
      })),
    );
  }

  renderTins(tins: TinAccess[]) {
    return tins.filter((tin) => tin.status === 'un assigned');
  }

  onUserCheck(userId: string, event: Event) {
    const checkbox = event.target as HTMLInputElement;

    if (checkbox.checked) {
      this.checkedUsers.push(userId);
    } else {
      this.checkedUsers = this.checkedUsers.filter((u) => u !== userId);
    }
  }

  onModifySelectedUsers(): void {
    this.editUsers(this.checkedUsers);
  }

  viewUserDetail(user: User) {
    const dialogRef = this.dialog.open(ManageAccessViewUserDialogComponent, {
      data: {
        user,
        isLoading: true,
        impersonator: false,
      },
      autoFocus: false,
      width: '800px',
    });

    dialogRef.componentInstance.editIndividualUser.subscribe(() => {
      this.editUsers([user.id]);
      dialogRef.close();
    });
  }

  editUsers(users: string[]) {
    this.router.navigate(['/my-practice/manage-access/assignment-method'], {
      queryParams: { users: users.join(',') },
    });
  }

  handlePagination(event: PageChangedEvent) {
    // eslint-disable-next-line sonarjs/prefer-immediate-return
    const offset = event.itemsPerPage * event.page - this.itemsPerPage;

    this.wamQuery.refetch({
      input: {
        offset,
        limit: this.itemsPerPage,
      },
    });
  }

  get modifyButtonEnabled() {
    return this.checkedUsers.length > 0;
  }
}
